import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'
import { AppBannerShelfStatus } from '@services/app'

type Props = {
  showAll?: boolean
} & SelectProps

export default function ShelfStatusSelect({
  showAll = false,
  ...props
}: Props) {
  const { t } = useTranslation()

  return (
    <Select allowClear {...props}>
      {showAll && (
        <Select.Option key="all" value="">
          {t('common:all')}
        </Select.Option>
      )}
      {AppBannerShelfStatus.map(item => (
        <Select.Option key={item.value} value={item.value}>
          {item.label}
        </Select.Option>
      ))}
    </Select>
  )
}
